import React, { FC, ReactNode } from "react";

interface Container {
  children: ReactNode;
  size: keyof typeof sizes;
  background?: keyof typeof backgrounds;
  classes?: string;
  padded?: keyof typeof paddedSizes;
}

const sizes = {
  small: "",
  medium: "max-w-5xl md:px-10",
  large: "max-w-7xl md:px-10",
  full: "w-full min-h-80",
};

const paddedSizes = {
  "py-small": "py-8",
  "py-medium": "py-16",
  "py-large": "lg:py-32 md:py-16 sm:py-8",
};

const backgrounds = {
  accent: "bg-accentBlueDark",
  accentLight: "bg-accentBlueLight",
  offset: "bg-backgroundOffset",
};

const Container: FC<Container> = ({
  children,
  classes,
  padded,
  size,
  background,
}) => {
  return (
    <div
      className={`m-auto ${sizes[size]} ${classes} ${padded ? paddedSizes[padded] : ""} ${background ? backgrounds[background] : ""}`}
    >
      {children}
    </div>
  );
};
export default Container;
